<template>
  <div class="meal-wrapper">
    <v-card>
      <v-card-title primary-title>
        Meal List
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          class="mx-8"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
        <v-dialog
          v-model="addNewModal"
          max-width="500px"
          transition="dialog-transition"
        >
          <template v-slot:activator="{ on }">
            <v-btn fab v-on="on">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>

          <v-card>
            <v-card-title>Add New Meal</v-card-title>
            <v-card-text>
              <v-text-field v-model="new_name" label="Name"></v-text-field>
              <v-combobox
                v-model="new_ingredients"
                chips
                clearable
                hide-details
                hide-selected
                label="Ingredients"
                multiple
                solo
              >
                <template v-slot:selection="{ attrs, item, select, selected }">
                  <v-chip
                    v-bind="attrs"
                    :input-value="selected"
                    close
                    @click="select"
                    @click:close="remove(item)"
                  >
                    <strong>{{ item }}</strong>
                  </v-chip>
                </template>
              </v-combobox>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="my-3" @click="addMeal">Save</v-btn>
              </v-card-actions>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-card-title>
      <v-data-table :headers="headers" :items="meals" :search="search">
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small @click="removeMeal(item.id)">
            mdi-delete
          </v-icon>
        </template>
        <template v-slot:item.ingredients="{ item }">
          <v-chip
            v-for="ingredient in item.ingredients"
            :key="ingredient.id"
            :color="ingredient.color"
            :dark="ingredient.dark"
          >
            {{ ingredient.text }}
          </v-chip>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Meals",
  data: () => ({
    addNewModal: false,
    headers: [
      { text: "Meal", value: "name" },
      { text: "Ingredients", value: "ingredients", filterable: false },
      {
        text: "Actions",
        value: "actions",
        sortable: false,
        filterable: false,
        align: "end"
      }
    ],
    meals: [],
    new_name: "",
    new_ingredients: [],
    search: ""
  }),
  mounted() {
    const vm = this;
    axios.get("http://localhost:3000/meals").then(resp => {
      vm.meals = resp.data;
    });
  },
  methods: {
    addMeal() {
      const ingredients = [];
      this.new_ingredients.forEach(i => {
        ingredients.push({
          text: i,
          dark: true,
          color: "black",
          id: Math.random()
        });
      });
      this.meals.push({
        id: Math.random(),
        name: this.new_name,
        ingredients
      });
      this.new_name = "";
      this.new_ingredients = [];
      this.addNewModal = false;
    },
    removeMeal(id) {
      this.meals = this.meals.filter(m => m.id !== id);
    }
  }
};
</script>

<style></style>
